module.exports = __webpack_public_path__ + "img/pack-sms.6c8d7795.png";